import React from "react";
import Landing from "../components/landing-page_components/Landing";

function LandingPage() {
  return (
    <div>
      <Landing />
    </div>
  );
}

export default LandingPage;
